import { collapseSelectedTable } from '../utils/collapse';
export var wrapTableInExpand = function wrapTableInExpand(state, dispatch) {
  var collapseTr = collapseSelectedTable(state.tr);
  if (!collapseTr) {
    return false;
  }
  if (dispatch) {
    dispatch(collapseTr);
  }
  return true;
};